import { render, staticRenderFns } from "./SchoolBrief.vue?vue&type=template&id=66929fdc&scoped=true&"
import script from "./SchoolBrief.vue?vue&type=script&lang=js&"
export * from "./SchoolBrief.vue?vue&type=script&lang=js&"
import style0 from "./SchoolBrief.vue?vue&type=style&index=0&id=66929fdc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66929fdc",
  null
  
)

export default component.exports